import { useTranslation } from "react-i18next";
import { Skeleton } from "@libs/zapi-ui/ds/components/skeleton";

const PARAGRAPHS = [
  { title: "w-28", lines: ["w-full", "w-full", "w-full", "w-full", "w-full", "w-full", "w-[83%]"] },
  { title: "w-40", lines: ["w-full", "w-full", "w-full", "w-full", "w-full", "w-[90%]"] },
  { title: "w-44", lines: ["w-full", "w-full", "w-full", "w-[60%]"] }
];

export function ChapterGeneratingSkeleton() {
  const { t } = useTranslation("projectHome");

  return (
    <div
      className="w-full h-full overflow-hidden px-16 py-10"
      role="status"
      aria-label={t("generation.generatingChapter")}
    >
      <div className="flex flex-col gap-10 max-w-[724px] mx-auto">
        {PARAGRAPHS.map((paragraph, index) => (
          <div key={index} className="flex flex-col gap-4">
            <Skeleton className={`h-6 ${paragraph.title}`} />
            <div className="flex flex-col gap-2.5">
              {paragraph.lines.map((width, lineIndex) => (
                <Skeleton key={lineIndex} className={`h-3.5 ${width}`} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
